import { Controller, ControllerProps } from "react-hook-form-mui";
import { MuiTelInput } from "mui-tel-input";
import { ReactNode } from "react";
import { Stack, InputLabel } from "@mui/material";
import { useTranslations } from "next-intl";

interface FormTelInputProps extends Omit<ControllerProps, "render"> {
  label?: ReactNode;
  placeholder?: string;
}

export const FormTelInput = ({
  label,
  disabled,
  placeholder,
  ...props
}: FormTelInputProps) => {
  const t = useTranslations();
  return (
    <Stack spacing={1} sx={{ opacity: disabled ? 0.7 : 1 }}>
      <InputLabel
        sx={{ fontWeight: 500, lineHeight: 1, textTransform: "capitalize" }}
      >
        {typeof label === "string" ? t(label) : label}
      </InputLabel>
      <Controller
        {...props}
        render={({ field }) => (
          <MuiTelInput
            InputProps={{
              sx: {
                borderRadius: "0.5rem",
                input: {
                  padding: 1.7,
                },
              },
            }}
            placeholder={placeholder}
            disabled={disabled}
            {...field}
          />
        )}
      />
    </Stack>
  );
};
